import { format } from 'date-fns'

export default function dateTimeFormatter(date) {
  if (date === null || date === undefined || date === '') {
    return ''
  }
  return format(new Date(date), 'dd-MM-yyyy - HH:mm:ss')
}
